import configConnect from 'preconf';
import defaults from '../config/default/config.json';

const configure = configConnect(null, defaults);
export { defaults, configure };
